import type { components } from '@fluencelabs/vodopad-admin-api'
import { useCustom } from '@refinedev/core'
import { Typography } from 'antd'
import { Link } from 'react-router-dom'

import { VODOPAD_ENDPOINT } from '@/constants/constants'
import type { PaginatedItems } from '@/types/api'

type UserPublicIpDto = components['schemas']['UserPublicIpDto']

interface Props {
  publicIpId: string
}

export function usePublicIp(publicIpId: string | null | undefined) {
  const ipQuery = useCustom<PaginatedItems<UserPublicIpDto>>({
    url: `${VODOPAD_ENDPOINT}/v1/admin/public_ips?ids[]=${publicIpId}&page=1&perPage=1`,
    method: 'get',
    queryOptions: { enabled: Boolean(publicIpId), staleTime: 5 * 60 * 1000 },
  })

  return (
    ipQuery.query.data?.data as PaginatedItems<UserPublicIpDto> | undefined
  )?.items?.[0]
}

export function PublicIpLink({ publicIpId }: Props) {
  const ip = usePublicIp(publicIpId)

  return (
    <Link
      to={`/network/${publicIpId}`}
      style={{
        textDecoration: 'underline',
        textDecorationStyle: 'dotted',
        textUnderlineOffset: 4,
      }}
    >
      <Typography.Text copyable={{ text: ip?.address ?? publicIpId }}>
        {ip?.address ?? ip?.name ?? `${publicIpId.slice(0, 8)}...`}
      </Typography.Text>
    </Link>
  )
}
